import { Card } from '@material-ui/core'
import React from 'react'

interface UrlMeta {
  author: string
  date: string
  description: string
  image: string
  logo: string
  publisher: string
  title: string
  url: string
}

const Link = () => {
  const [url, setUrl] = React.useState('')
  const [meta, setMeta] = React.useState<UrlMeta | null>(null)
  return (
    <div>
      <div>
        <input type="text" onChange={e => setUrl(e.target.value)} />
        <button
          onClick={() =>
            fetch('https://api.staging.schema.team/metascraper', {
              headers: {
                accept: '*/*',
                'content-type': 'application/json',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'same-site'
              },
              method: 'POST',
              mode: 'cors',
              body: JSON.stringify({ url })
            }).then(async res => {
              setMeta(await res.json())
            })
          }
        >
          Resolve Link
        </button>
      </div>
      {meta && (
        <Card style={{ display: 'flex' }} elevation={3} variant="outlined">
          <img
            src={meta.image}
            height="100px"
            width="100px"
            style={{ marginRight: 15 }}
            alt=""
          />
          <div>
            <a href="url">{meta.title}</a>
            <div>{meta.description}</div>
          </div>
        </Card>
      )}
    </div>
  )
}

export default Link
